﻿import React, { useState } from 'react';

import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { FormattedMessage } from 'react-intl';
import { License } from 'apis/TransactionApi';

interface OrderTransactionListProps {
    licenseHistory: License[];
    orderIds: number[];
}

const OrderTransactionList = ({ licenseHistory, orderIds }: OrderTransactionListProps) => {

    const [showAllLicenses, setShowAllLicenses] = useState(false);

    const uniqueLicenses = [
        ...new Map(
            (licenseHistory || [])
                .filter(license => orderIds?.includes(license.OrderId))
                .map(license => [license.LicenseId, license])
        ).values()
    ];

    return (
        <>
            {uniqueLicenses.length > 0 && (
            <div className="mt-2">
                <strong>
                    <FormattedMessage defaultMessage="Licenses" id="licenses.11b1c36a" />
                </strong>
                <br />

                {uniqueLicenses
                    .slice(0, showAllLicenses ? uniqueLicenses.length : 3)
                    .map(license => (
                        <div key={license.LicenseId}>
                            {license.LicenseName}
                        </div>
                    ))}

                {uniqueLicenses.length > 3 && (
                <GMetrixButton
                    className="p-0 mt-1"
                    onClick={() => setShowAllLicenses(!showAllLicenses)}
                    size="sm"
                    variant="link"
                >
                    {showAllLicenses ? <FormattedMessage defaultMessage="View Less" id="view_less.c8a23c73" /> : <FormattedMessage defaultMessage="View More" id="view_more.5460a55f" />}
                </GMetrixButton>
                )}
            </div>
            )}
        </>
    );

};

export default OrderTransactionList;